const joinTeamModule = document.querySelectorAll('.sc-join-team');
joinTeamModule.forEach((el) => {
  const stickyStartPoint = el.querySelector('.join-team__animation-trigger');
  const stickyElement = el.querySelector('.join-team');
  const imagesSlider = el.querySelector('.join-team__slider-inner');
  const stickyHeight = stickyStartPoint.offsetHeight;
  let controllerJoinTeamModule = null;
  controllerJoinTeamModule = new ScrollMagic.Controller();

  const initStickyElementScene = () => {
    const scene = new ScrollMagic.Scene({
      triggerElement: stickyStartPoint,
      duration: stickyHeight,
      triggerHook: 0,
    })
      .setTween(imagesSlider, { xPercent: '-80' })
      .setPin(stickyElement)
      .addTo(controllerJoinTeamModule);

    if (isLocal()) {
      scene.addIndicators({ name: 'Sticky' });
    }
  };

  initStickyElementScene();
});
